import { useState } from 'react'

import Login from './Login'
import RequestPasswordReset from './RequestPasswordReset'
import ResetPassword from './ResetPassword'

const Access = () => {
  const [accessPage, setAccessPage] = useState('login')
  const [forgotPasswordUsername, setForgotPasswordUsername] = useState(null)

  const handleGoToRequestPasswordReset = () =>
    setAccessPage('requestPasswordReset')

  const handleSuccessRequestPasswordReset = username => {
    setForgotPasswordUsername(username)
    setAccessPage('resetPassword')
  }

  return accessPage === 'login' ? (
    <Login onClickRequestPasswordReset={handleGoToRequestPasswordReset} />
  ) : accessPage === 'requestPasswordReset' ? (
    <RequestPasswordReset
      forgotPasswordUsername={forgotPasswordUsername}
      onSuccessRequest={handleSuccessRequestPasswordReset}
    />
  ) : accessPage === 'resetPassword' ? (
    <ResetPassword
      forgotPasswordUsername={forgotPasswordUsername}
      onResendCode={handleGoToRequestPasswordReset}
    />
  ) : null
}

export default Access
